<div class="payment-page">


<div class="page-header">


<h2>
Merchant Payments
</h2>


<p>
Track customer payment history and payment status
</p>


</div>





<div
class="empty"

*ngIf="payments.length===0">


No payment records available


</div>







<div
class="payment-grid">





<div
class="payment-card"

*ngFor="let payment of payments">





<!-- HEADER -->

<div class="card-header">


<h3>

{{payment.service_name}}

</h3>



<span

class="status"

[ngClass]="{


'paid':
payment.payment_status==='Paid'
||
payment.payment_status==='Completed',


'pending':
payment.payment_status==='Pending'


}">


{{payment.payment_status}}


</span>


</div>







<!-- PAYMENT INFORMATION -->

<div class="payment-info">





<div>

<strong>
Customer Email
</strong>

<p>
{{payment.customer_email}}
</p>

</div>






<div>

<strong>
Payment Type
</strong>

<p>
{{payment.payment_type}}
</p>

</div>







<div>

<strong>
Total Amount
</strong>

<p>
₹ {{payment.total_amount}}
</p>

</div>







<!-- ADVANCE -->


<div

*ngIf="payment.payment_type==='Advance'">


<strong>
Advance Paid
</strong>


<p>
₹ {{payment.advance_amount}}
</p>


</div>






<!-- REMAINING -->


<div

*ngIf="payment.remaining_amount > 0">


<strong>
Remaining Amount
</strong>


<p>
₹ {{payment.remaining_amount}}
</p>


</div>






</div>









<!-- ACTION -->

<div class="action">


<button>

View Details

</button>



</div>







</div>





</div>





</div>